import { useRef } from 'react'

/**
 * Returns tooltip timer function
 * @param {boolean} isHovered - Hover state
 * @param {function} setIsHovered - Set hover state function
 * @param {number} delayShow - Time in ms before tooltip shows after mouse entry
 * @param {number} delayClose - Time in ms before tooltip closes after mouse exit
 */
export function useHover(
  isHovered,
  setIsHovered,
  delayShow = 500,
  delayClose = 100,
) {
  const tooltipTimer = useRef()
  return {
    onMouseEnter: () => {
      if (!isHovered) {
        tooltipTimer.current = setTimeout(() => {
          setIsHovered(true)
        }, delayShow)
      }
    },
    onMouseLeave: () => {
      clearTimeout(tooltipTimer.current)
      if (isHovered) {
        tooltipTimer.current = setTimeout(() => {
          setIsHovered(false)
        }, delayClose)
      }
    },
  }
}
